import { useTranslation } from "react-i18next"

export const GlobalRank = ({ examGroupData }) => {
  const { t } = useTranslation()
  return (
    <div
      className="text-left d-flex flex-row gap-3"
      style={{ color: "black", fontWeight: "bold", textAlign: "left", fontSize: "120%" }}>
      <span>
        {t("exam")}: {examGroupData.name}
      </span>{" "}
      <span>
        {t("total_points")}: {examGroupData.total}
      </span>
      <span>{t("rank_in_class")}:</span>
      <span>{examGroupData?.rank_in_city}</span>
      <span>{t("rank_in_classes")}:</span>
      <span>{examGroupData?.rank_in_country}</span>
    </div>
  )
}
